var magicStyles = [".content[data-v-458c88d1]{margin:0 0 var(--magic-space,16px)}"];

export default magicStyles;
